import { ShippingCarriers } from "../shippingCarriers";
import { ShippingService } from "../shippingRates.types";
import { getPricesWithVAT } from "../utils";

export const ebayPacklink_shop2shop: ShippingService = {
    serviceCode: 'ebayPacklink_shop2shop',
    description: 'Buying on eBay, through Packlink platform expeditions.ebay.fr',
    appliesVolumetricWeight: false,
    maxDimensions: (size1: number, size2: number, size3: number, weight: number) => {
        if (weight >= 30000) {
            return { isValid: false, errorMessage: 'Max weight exceeded (30kg).' };
        }
        const calculation = size1 + size2 + size3;
        if (calculation > 150) {
            return { isValid: false, errorMessage: 'Max dimensions exceeded (150cm). Calculation is Length + Width + Height' };
        }
        return { isValid: true, errorMessage: '' };
    },
    deliveryType: 'pickup',
    carrier: ShippingCarriers.chronopost,
    conditions: {
        orderPlatform: 'ebay',
    },

    externalMappings: {
        ebay: {
            carrierCode: 'Chronopost',
            serviceCode: 'FR_Shop2Shop',
        },
    },

    ratesByDestination: [
        {
            destinations: ['FR'],
            rates: [
                {
                    minWeight: 0,
                    maxWeight: 2000,
                    ...getPricesWithVAT(3.96),
                },
                {
                    minWeight: 2000,
                    maxWeight: 3000,
                    ...getPricesWithVAT(4.75),
                },
                {
                    minWeight: 3000,
                    maxWeight: 5000,
                    ...getPricesWithVAT(6.06),
                },
                {
                    minWeight: 5000,
                    maxWeight: 6000,
                    ...getPricesWithVAT(6.72),
                },
                {
                    minWeight: 6000,
                    maxWeight: 7000,
                    ...getPricesWithVAT(7.38),
                },
                {
                    minWeight: 7000,
                    maxWeight: 8000,
                    ...getPricesWithVAT(8.04),
                },
                {
                    minWeight: 8000,
                    maxWeight: 9000,
                    ...getPricesWithVAT(8.70),
                },
                {
                    minWeight: 9000,
                    maxWeight: 10000,
                    ...getPricesWithVAT(9.36),
                },
                {
                    minWeight: 10000,
                    maxWeight: 11000,
                    ...getPricesWithVAT(10.02),
                },
                {
                    minWeight: 11000,
                    maxWeight: 12000,
                    ...getPricesWithVAT(10.68),
                },
                {
                    minWeight: 12000,
                    maxWeight: 13000,
                    ...getPricesWithVAT(11.34),
                },
                {
                    minWeight: 13000,
                    maxWeight: 14000,
                    ...getPricesWithVAT(12.00),
                },
                {
                    minWeight: 14000,
                    maxWeight: 15000,
                    ...getPricesWithVAT(12.66),
                },
                {
                    minWeight: 15000,
                    maxWeight: 16000,
                    ...getPricesWithVAT(13.32),
                },
                {
                    minWeight: 16000,
                    maxWeight: 17000,
                    ...getPricesWithVAT(13.98),
                },
                {
                    minWeight: 17000,
                    maxWeight: 18000,
                    ...getPricesWithVAT(14.64),
                },
                {
                    minWeight: 18000,
                    maxWeight: 19000,
                    ...getPricesWithVAT(15.30),
                },
                {
                    minWeight: 19000,
                    maxWeight: 20000,
                    ...getPricesWithVAT(15.96),
                },
            ]
        },
    ]
}